// @flow
import React from 'react';
import PropTypes from 'prop-types';

import style from './RadioButton.scss';
import icons from '../../../../../../../../assets/styles/icons.scss';

type Props = {
  name: string;
  checked: boolean;
};

export default function RadioButton(props: Props) {
  const { checked, name } = props;
  return (
    <label className={style.radioInputWrap}>
      <input type="radio"
             name={name}
             checked={checked}
             readOnly/>
      <span className={style.checkmark}><i className={icons.iconCheckMedium}/></span>
    </label>
  );

}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/ForecastBox/CustomRadioButton/RadioButton.jsx